import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import dayjs from "dayjs";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import { toast } from "react-hot-toast";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { Tables } from "../../components/Elements/Tables/Tables";
import { SearchBar } from "../../components/Elements/Search/SearchBar";

const Subscribers = () => {
  const [loading, setLoading] = useState(false);
  const [subscribers, setSubscribers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [totalSubscribers, setTotalSubscribers] = useState(0);
  const pageSize = 10;

  const headers = useMemo(
    () => [
      { label: "S.No", key: "sno" },
      { label: "Email ID", key: "email" },
      { label: "Date Subscribed", key: "createdAt" },
      { label: "Status", key: "isActive" },
    ],
    []
  );

  const fetchSubscribers = async (page = 1, search = "") => {
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_SUBSCRIBERS(page, pageSize, search),
      });

      if (response.success) {
        const mappedData = response.data.map((sub, index) => ({
          key: sub._id,
          sno: (page - 1) * pageSize + index + 1,
          email: sub.email,
          createdAt: dayjs(sub.createdAt).format("MMM DD, YYYY HH:mm A"),
          isActive: (
            <span
              className={`px-3 py-1 rounded-full text-xs font-semibold ${
                sub.isActive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
              }`}
            >
              {sub.isActive ? "Active" : "Inactive"}
            </span>
          ),
        }));
        setSubscribers(mappedData);
        setTotalSubscribers(response.totalCount);
      } else {
        toast.error(response.message || "Failed to fetch subscribers");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSubscribers(pageNo, searchQuery);
    }, 500);
    return () => clearTimeout(timer);
  }, [pageNo, searchQuery]);

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div>
        <div className="flex justify-end text-xs font-light p-3">
          <p>Home</p>
          <span className="mx-1">/</span>
          <TextStyles color="gradient">Subscribers</TextStyles>
        </div>
        <div>
          <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold px-2">
            <div>Subscribers</div>
          </div>

          <div
            style={{
              border: "1px solid #3BA2B959",
              borderRadius: "10px",
              paddingTop: "20px",
              boxShadow: "0px 0px 16px 0px #3BA2B91F",
            }}
          >
            <div className="flex justify-between px-3 mb-3">
              <div className="flex gap-4 pl-9">
                <div className="px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
                  TOTAL SUBSCRIBERS {totalSubscribers}
                </div>
                <SearchBar
                  width="300px"
                  onSearch={(value) => {
                    setSearchQuery(value);
                    setPageNo(1);
                  }}
                />
              </div>
            </div>
            
            <Tables
              data={subscribers}
              headers={headers}
              pageSize={pageSize}
              current={pageNo}
              total={totalSubscribers}
              loading={loading}
              onChange={(page) => {
                setPageNo(page);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscribers;
